<div class="frame-window">
    <iframe [src]="item | safe" scrolling="no" allowfullscreen></iframe>
</div>